/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import FullPageLayout from "../../../templates/FullPageLayout";
import { Button, Card, Col, Image, Row } from "antd";
import { NeedHelp } from "../../../atoms/CustomIcons";
import { useAppDispatch, useAppSelector } from "../../../config/hooks";
import { getPotentialDealDetails, getProposalDoc } from "../ducks/actions";
import { PlusOutlined } from "@ant-design/icons";
import DragIcon from "../../../atoms/CustomIcons/DragIcon";
import DocumentHeader from "../Estimates/Components/DocumentHeader";

export default function DocumentEditor() {
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();
  const locationUrl = window.location.pathname;
  const pathSegments = locationUrl.split("/");
  const companyId = pathSegments[pathSegments.length - 1];
  const estimateId = pathSegments[pathSegments.length - 2];
  const proposalId = pathSegments[pathSegments.length - 3];

  const proposalBuilderData = useAppSelector(
    (state) => state?.potentialDeal?.proposalBuilderData
  );

  useEffect(() => {
    if (proposalId) {
      const payload = {
        proposal_id: proposalId,
      };
      dispatch(getProposalDoc(payload));
    }
  }, [dispatch, proposalId]);

  const dealsDetailData = useAppSelector(
    (state) => state?.potentialDeal?.dealsDetailData
  );

  const proposalDetailData = useAppSelector(
    (state) => state?.potentialDeal?.proposalDetailData
  );

  useEffect(() => {
    if (estimateId) {
      dispatch(getPotentialDealDetails(estimateId));
    }
  }, [dispatch, estimateId]);

  // const modules = {
  //   toolbar: [
  //     [{ header: [1, 2, false] }], // Headers: H1, H2, or normal text
  //     ["bold", "italic", "underline", "strike"], // Bold, Italic, Underline, Strikethrough
  //     [{ list: "ordered" }, { list: "bullet" }], // Ordered and unordered lists
  //     [{ indent: "-1" }, { indent: "+1" }], // Outdent/Indent
  //     [{ color: [] }, { background: [] }], // Text color and background color
  //     [{ align: [] }], // Text alignment
  //     ["link", "image"], // Link and Image buttons
  //     ["clean"], // Remove formatting button
  //   ],
  // };

  return (
    <FullPageLayout loading={loading || proposalBuilderData?.loader}>
      <div className="estimateWrapper">
        <DocumentHeader
          companyId={companyId}
          estimateId={estimateId}
          btnText1="Need help?"
          btnIcon1={<NeedHelp />}
          setLoading={setLoading}
          dealsDetailData={dealsDetailData?.data}
          proposalDetailData={proposalDetailData}
          addProposal={true}
          handleSubmitEstimate={() => null}
        />

        <Card
          className="editorContent editorContentTemplate"
          style={{ margin: 0 }}
        >
          <Row gutter={12} wrap={false}>
            <Col flex="234px">
              <Card style={{ backgroundColor: "#F6F9F9", border: "unset" }}>
                <div className="editorHeader">
                  <h3> Sections </h3>
                  <Button
                    icon={<PlusOutlined />}
                    style={{
                      backgroundColor: "#fff",
                      height: "28px",
                      width: "28px",
                    }}
                  />
                </div>
                <div className="editorBody">
                  <ul>
                    <li>Cover</li>
                    <li>
                      <DragIcon style={{ marginRight: "8px" }} /> Summary
                    </li>
                    <li>
                      <DragIcon style={{ marginRight: "8px" }} />
                      Scope of work
                    </li>
                    <li>
                      <DragIcon style={{ marginRight: "8px" }} />
                      Pricing
                    </li>
                    <li>
                      <DragIcon style={{ marginRight: "8px" }} />
                      Terms & conditions
                    </li>
                    <li>Signatures</li>
                  </ul>
                </div>
                {/* <div className="editorHeader" style={{ marginTop: "16px" }}>
                  <h3> Attachments </h3>
                </div>
                <div className="editorBody">
                  <ul>
                    <li>
                      <WordIcon style={{ marginRight: "8px" }} />
                      Grass
                    </li>
                    <li style={{ color: "#474C4D" }}>
                      <PlusIcon style={{ marginRight: "8px" }} />
                      Add files
                    </li>
                  </ul>
                </div> */}
              </Card>
            </Col>
            <Col flex="auto">
              <div className="document-toolbar">
                <Image
                  src="/images/potential-deals/toolbar.svg"
                  preview={false}
                />
              </div>
              <Card
                className="documentEditor additional_card_ui"
                style={{
                  margin: 0,
                  backgroundColor: "#DBF1EA",
                  border: "unset",
                }}
              >
                {/* <div className="documentWrapper">
                  <div className="documentCover">
                    <div className="documentTitle">
                      <ReactQuill
                        modules={modules}
                        placeholder="Proposal title"
                      />
                    </div>
                  </div>
                </div> */}

                <div
                  className="documentWrapper additional_ui"
                  // The core of rendering raw HTML in React
                  dangerouslySetInnerHTML={{
                    __html: proposalBuilderData?.data || "",
                  }}
                />
              </Card>
            </Col>
          </Row>
        </Card>
      </div>
    </FullPageLayout>
  );
}
